import type { Components } from '@mui/material/styles';

export default function MUISpeedDialAction(): Components['MuiSpeedDialAction'] {
  return {};
}
